export const CATALOG_PAGE = 1;
export const FREE_HTML_PAGE = 2;
export const BANNER_AND_FREE_HTML_PAGE = 3;
export const BANNER_AND_FREE_HTML_PAGE_W_ITEMS = 4;
export const SERVICE_DETAIL_PAGE = 5;
export const HOME_PAGE= 6;
export const CONTACT_PAGE = 7;
export const COMPANY_INFORMATION_PAGE = 8;
export const PUBLICATIONS_PAGE = 9;
